




/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const ALUMNIPOSTLIKE= createAsyncThunk(
  "aluminipostlike/aluminipostlike",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const aluminipostlikeSlice = createSlice({
  name: "aluminipostlikeSlice",
  initialState: {
    aluminipostlike: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfaluminipostlike: (state) => {
        state.aluminipostlike.loading = false
        state.aluminipostlike.error = false
        state.aluminipostlike.data = []
        state.aluminipostlike.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ALUMNIPOSTLIKE.fulfilled, (state, action) => {
      state.aluminipostlike = {
        ...state.aluminipostlike,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ALUMNIPOSTLIKE.pending, (state, action) => {
      state.aluminipostlike = {
        ...state.aluminipostlike,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ALUMNIPOSTLIKE.rejected, (state, action) => {
      state.aluminipostlike = {
        ...state.aluminipostlike,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const aluminipostlikeAction = {
    ALUMNIPOSTLIKE,
};

export { aluminipostlikeAction };
export default aluminipostlikeSlice.reducer;
export const {setInitialStateOfaluminipostlike} = aluminipostlikeSlice.actions
